import React from 'react'

const LocalUsers = () => {
  return (
    <div>LocalUsers</div>
  )
}

export default LocalUsers